<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemStore',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-store-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="店铺名称">
                <a-input v-model:value="state.tableData.param.storeName" placeholder="请输入店铺名称" :maxlength="30"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="所属行业">
                <a-input v-model:value="state.tableData.param.industryName" placeholder="请输入所属行业" :maxlength="100"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="店铺类型">
                <a-select v-model:value="state.tableData.param.storeTypeCode" placeholder="请选择店铺类型" allow-clear>
                  <a-select-option v-for="item in storeTypeList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="add mr-[10px]!" @click="openDialog('add', {})" type="primary">
                  <PlusOutlined />新增店铺
                </ant-button>
                <ant-button class="setting" @click="goStoreType" type="primary">
                  <SettingOutlined />店铺类型配置
                </ant-button>
              </div>
            </a-col> -->
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog('detail', record)">查看</a-button>
              <!-- <a-button type="link" size="small" @click="openDialog('edit', record)">编辑</a-button> -->
              <!-- <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'shop.del'">删除</a-button> -->
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <StoreDialog ref="dialogRef" :store-type-list="storeTypeList" :venue-type-tree="venueTypeList"
      :area-tree-options="areaTreeOptions" @create-update="createUpdate" />
    <StoreDetailDialog ref="detailDialogRef" />
  </div>
</template>

<script setup lang="ts" name="systemStore">
import { reactive, ref, onMounted, h } from 'vue'
import { useRouter } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import {
  SearchOutlined,
  RedoOutlined,
  PlusOutlined,
  SettingOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { useStore } from '@/store/shop/store'
import { useStoreType } from '@/store/shop/storeType'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import StoreDialog from './dialog.vue'
import StoreDetailDialog from './detailDialog.vue'

const storeStore = useStore()
const storeTypeStore = useStoreType()
const dictionaryStore = useDictionary()
const router = useRouter()
const dialogRef = ref()
const detailDialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 80, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '店铺类型', dataIndex: 'storeTypeStr', key: 'storeTypeStr', ellipsis: true },
  { title: '场所业态类型', dataIndex: 'venueTypeStr', key: 'venueTypeStr', ellipsis: true },
  { title: '所属行业', dataIndex: 'industryStr', key: 'industryStr', ellipsis: true },
  { title: '店铺名称', dataIndex: 'storeName', key: 'storeName', ellipsis: true },
  { title: '店铺地址', dataIndex: 'areaStr', key: 'areaStr', ellipsis: true, customRender: ({ record }: { record: any }) => [record.areaStr, record.detailAddress].filter(Boolean).join('') || '-' },
  { title: '店铺面积', dataIndex: 'buildingArea', key: 'buildingArea', width: 100, customRender: ({ text }: { text: any }) => text ? `${text}㎡` : '-' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime', minWidth: 160, ellipsis: true },
  // { title: '创建人', dataIndex: 'userNickname', key: 'userNickname', width: 100 },
  // { title: '联系人', dataIndex: 'contactPerson', key: 'contactPerson', width: 100 },
  // { title: '联系电话', dataIndex: 'contactPhone', key: 'contactPhone', width: 120 },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      storeName: '',
      industryName: '',
      storeTypeCode: undefined as string | undefined
    }
  }
})

const storeTypeList = ref<any[]>([])
const venueTypeList = ref<any[]>([])
const areaTreeOptions = ref<any[]>([])

const resetFun = () => {
  state.tableData.param.storeName = ''
  state.tableData.param.industryName = ''
  state.tableData.param.storeTypeCode = undefined
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const params: any = { ...state.tableData.param }
    const data: any = await fetchWithPaginationFallback(
      (param) => storeStore.getStorePage(param),
      params
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (type: string, row: any) => {
  if (type === 'add') {
    dialogRef.value.openDialog(type, row)
  } else if (type === 'detail') {
    storeStore.getStoreInfo(row.id).then((data: any) => {
      detailDialogRef.value.openDialog(data)
    })
  } else {
    storeStore.getStoreInfo(row.id).then((data: any) => {
      dialogRef.value.openDialog(type, data)
    })
  }
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除店铺："${row.storeName}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return storeStore.deleteStore(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = () => {
  message.success('操作成功')
  getTableData()
  dialogRef.value.closeDialog()
}

const goStoreType = () => {
  router.push('/shop/shopType')
}

const init = async () => {
  const data: any = await dictionaryStore.getDict({ code: 'store_type' })
  storeTypeList.value = data || []
  const venueTypeData: any = await storeTypeStore.getStoreTypeTree({ typeGroup: 'venue' })
  venueTypeList.value = venueTypeData || []
  const areaData: any = await dictionaryStore.getAreaTree()
  areaTreeOptions.value = areaData || []
  getTableData()
}

onMounted(() => {
  init()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
